import { React, useState, useEffect, useRef } from 'react';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { useParams, useNavigate, useLocation, } from "react-router-dom";
import { useDispatch, useStore, useSelector } from 'react-redux';
import M from '@materializecss/materialize';
import TagManager from 'react-gtm-module';
import ImeField from '../field/ImeField';
import EmailField from '../field/EmailField';
import MobitelField from '../field/MobitelField';
import FormSubmitField from '../field/FormSubmitField';
import AgreeField from '../field/AgreeField';
import HiddenField from '../field/HiddenField';
import PodpisField from '../field/PodpisField';
import PodpisField1 from '../field/PodpisField1';
import FormStepButtonField from '../field/FormStepButtonField';
import NaslovField from '../field/NaslovField';
import SpolField from '../field/SpolField';
import DatumRojstvaField from '../field/DatumRojstvaField';
import DavcnaStevilkaField from '../field/DavcnaStevilkaField';
import DrzavaRojstvaField from '../field/DrzavaRojstvaField';
import DrzavaRojstvaTextField from '../field/DrzavaRojstvaTextField';
import DrzavaPrebivaliscaTextField from '../field/DrzavaPrebivaliscaTextField';
import PoklicField from '../field/PoklicField';
import DediscinaField from '../field/DediscinaField';
import DediscinaDrugeOsebeField from '../field/DediscinaDrugeOsebeField';
import PaketField from '../field/PaketField';
import NacinPlacilaField from '../field/NacinPlacilaField';
import FrekvencaField from '../field/FrekvencaField';
import CenaField from '../field/CenaField';
import IbanField from '../field/IbanField';
import ImeBankeField from '../field/ImeBankeField';
import DaNeField from '../field/DaNeField';
import PaketDrBestField from '../field/PaketDrBestField';
import PrenosPodatkovField from '../field/PrenosPodatkovField';
import KrajPodpisaField from '../field/KrajPodpisaField';
import FormStepsField from '../field/FormStepsField';
import OsebniDokumentIdField from '../field/OsebniDokumentIdField';
import OsebniDokumentTipField from '../field/OsebniDokumentTipField';
import OsebniDokumentIzdajateljField from '../field/OsebniDokumentIzdajateljField';
import OsebniDokumentDatumIzdajeField from '../field/OsebniDokumentDatumIzdajeField';
import IzborZavarovancaField from '../field/IzborZavarovancaField';
import PotrditvenaKodaField from '../field/PotrditvenaKodaField';
import PotrditvenaKoda2Field from '../field/PotrditvenaKoda2Field';
import ZavarovanciArrayField from '../field/ZavarovanciArrayField';
import RazmerjeField from '../field/RazmerjeField';
import PredogledArea from '../other/PredogledArea';
import Predogled2Area from '../other/Predogled2Area';
import Predogled2Table from '../other/Predogled2Table';
import MessageBox from '../other/MessageBox';
import DaNeKanaliGroup from '../part/DaNeKanaliGroup';
import ItemPonudbaService from '../service/ItemPonudbaService';
import {
    getActionType, parseFieldName, inputValueToUpperCase,
    formatDecimal, datumEuToTimestamp
} from '../redux/common';
import {
    reduxSelectZavarovalecAmTrustGdprKanaliShow,
    reduxSelectZavarovanaOsebaAmTrustGdprKanaliShow,
    reduxSelectIsZavarovalecAmTrustGdprKanalRequired,
    reduxSelectIsZavarovanaOsebaAmTrustGdprKanalRequired
} from '../redux/selectors';
import { BdcaPremija } from 'eureko-lib';
import { DOCUMENT_URLS } from '../url';
import { appLogDebug,
    validateFormInputs, 
    validateFormSignatures, 
    validateFormSignature,
    markInvalidTabs, 
    mapErrorsToForm,
    markInput
} from '../helper';
import { ZAVAROVANEC_PREMIJA_UPDATED } from '../redux/types/zavarovanaOsebaType';
import { APP_CORE_OTP_UPDATED } from '../redux/app.core/types/appCoreType';
import IdentityService from '../service/IdentityService';


export default function DrBestBasicFrom(props) {
    const store = useStore();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [status, setStatus] = useState('');
    const [otpId, setOtpId] = useState(null);
    const [pdfContent, setPdfContent] = useState(null);
    const [signedPdfContent, setSignedPdfContent] = useState(null);

    // We only need to use this state var on instances where <PrenosPodaktov> component needs to initially 
    // fill out the fields. We do this so we can trigger "re-copy" of data.
    const [kopirajPodatke, setKopirajPodatke] = useState(true);

    // Form steps.
    const formStepsEl = useRef(null);
    //const allSteps = [
    const [allSteps, setAllSteps] = useState([
        {
            step: 1,
            tab: 'zavarovalec-data',
            text: "Zavarovalec",
            error: false,
            isActive: true,
            title: "Zavarovalec",
            status: null
        },
        {
            step: 2,
            tab: 'zavarovanec-data',
            text: "Zavarovanci",
            error: false,
            isActive: false,
            title: "Zavarovanci",
            status: null
        },
        {
            step: 3,
            tab: 'premija',
            text: "Premija",
            error: false,
            isActive: false,
            title: "Premija",
            status: null,
        },
        {
            step: 4,
            tab: 'sepa',
            text: "SEPA",
            error: false,
            isActive: false,
            title: "SEPA",
            status: null
        },
        {
            step: 5,
            tab: 'izjava',
            text: "Izjave",
            error: false,
            isActive: false,
            title: "Izjave",
            status: null
        },
        {
            step: 6,
            tab: 'gdpr',
            text: "GDPR",
            error: false,
            isActive: false,
            title: 'GDPR',
            status: null
        },
        {
            step: 7,
            tab: 'veljavnost-podatkov',
            text: "Veljavnost podatkov",
            error: false,
            isActive: false,
            title: "Veljavnost podatkov",
            status: null
        },
        {
            step: 8,
            tab: 'form-final',
            text: "Predogled in oddaja",
            error: false,
            isActive: false,
            title: "Predogled in Oddaja",
            status: null
        }
    ]);
    const [pdfStatus, setPdfStatus] = useState('');
    const [documents, setDocuments] = useState([
        {
            apiId: 'PONUDBA',
            id: 'PONUDBA',
            content: '',
            isActive: false,
            isAllowed: true,
            text: 'Ponudba za sklenitev zavarovanja'
        },
        {
            apiId: 'SEPA',
            id: 'SEPA',
            content: '',
            isActive: false,
            isAllowed: true,
            text: 'Soglasje za direktno obremenitev (SEPA)'
        },
        {
            apiId: 'IPID',
            id: 'IPID',
            content: '',
            isActive: false,
            isAllowed: true,
            text: 'Dokument z informacijami o zavarovalnem produktu (IPID)'
        },
        {
            apiId: 'SPLOŠNI POGOJI',
            id: 'SPLOSNI_POGOJI',
            content: '',
            isActive: false,
            isAllowed: true,
            text: 'Splošni pogoji'
        }

    ]);

    const [podpisiErrors, setPodpisiErrors] = useState({
        'sepaplacnik_podpisPlacnika': {
            hasError: false
        },
        'produkt_podpisZavarovalec': {
            hasError: false
        },
        'zavarovanec_izjavazavarovanca_podpisZavarovanec': {
            hasError: false
        },
        'zavarovalec_amtrust_izjavagdpr_podpis': {
            hasError: false
        },
        'zavarovanec_izjavagdpr_podpis': {
            hasError: false
        },
        'zavarovanec_pristopabi_podpis': {
            hasError: false
        },
        /*'zavarovanec_pristopabi_izjavagdpr_podpis': {
            hasError: false
        }*/
    });

    const [currentStep, setCurrentStep] = useState(allSteps[0]);

    // Refs.
    const imeBankeInput = useRef(null);

    /** -- BEGIN: PotrditvenaKoda2 --- 
     * @todo revisit this and put it in eureko-lib.
    */
    const [potrditvenaKodaError, setPotrditvenaKodaError] = useState({ hasError: false });
    const [potrditvenaKodaSent, setPotrditvenaKodaSent] = useState(false);

    const selectZavarovalecAmTrustGdprKanaliShow = useSelector(reduxSelectZavarovalecAmTrustGdprKanaliShow);
    const selectZavarovanaOsebaAmTrustGdprKanaliShow = useSelector(reduxSelectZavarovanaOsebaAmTrustGdprKanaliShow);

    const selectSepaPlacnikPodpisPlacnika = useSelector((state) => {
        try {
            return state.sepa.placnik.podpisPlacnika;
        } catch(e) {
            return null;
        }
    });

    const selectProduktPodpisZavarovalec = useSelector((state) => {
        try {
            return state.produkt.rootProdukt.podpisZavarovalec;
        } catch(e) {
            return null;
        }
    });

    // zavarovalec_amtrust_izjavagdpr_q61
    const selectZavarovalecAmTrustIzjavaGdprHasWarning = useSelector((state) => {
        try {
            let daNeValue = state.zavarovalec.amTrust.izjavaGDPR.q61;
            if (daNeValue === 'N') {
                return true;
            }
        }  catch(e) {
            return false;
        }

        return false;
    });

    // zavarovalec_amtrust_izjavagdpr_podpis
    const selectZavarovalecAmTrustIzjavaGdprPodpis = useSelector((state) => {
        try {
            return state.zavarovalec.amTrust.izjavaGDPR.podpis
        } catch(e) {
            return null;
        }
    });

    // zavarovanec_amtrust_izjavagdpr_q61
    const selectZavarovanecAmTrustIzjavaGdprHasWarning = useSelector((state) => {
        try {
            let daNeValue = state.produkt.zavarovanaOseba.izjavaGDPR.q61;
            if (daNeValue === 'N') {
                return true;
            }
        }  catch(e) {
            return false;
        }

        return false;
    });

    const selectIsZavarovalecAmTrustGdprKanalRequired = useSelector(
        reduxSelectIsZavarovalecAmTrustGdprKanalRequired
    );
    const selectIsZavarovanaOsebaAmTrustGdprKanalRequired = useSelector(
        reduxSelectIsZavarovanaOsebaAmTrustGdprKanalRequired
    );

    const selectZavarovanecIzjavaMessageClass = useSelector((state) => {
        let hideCl = 'hide';

        if (typeof (state.produkt) === 'undefined') {
            return '';
        }

        if (typeof (state.produkt.zavarovanaOseba) === 'undefined') {
            return '';
        }

        if (typeof (state.produkt.zavarovanaOseba.izjavaZavarovanca) === 'undefined') {
            return '';
        }

        let daNeValues = state.produkt.zavarovanaOseba.izjavaZavarovanca;
        for (let k in daNeValues) {
            if (daNeValues[k] == 'D') {
                return '';
            }
        }

        return hideCl;
    });

    const selectKopiranSepaPlacnik = useSelector((state) => {
        try {
            return state.meta.kopiranSepaPlacnik;
        } catch (e) {
            return true;
        }
    });

    const selectPlacnikIban = useSelector((state) => {
        if (typeof (state.sepa) === 'undefined') {
            return '';
        }
        else if (typeof (state.sepa.placnik) === 'undefined') {
            return '';
        }
        else if (typeof (state.sepa.placnik.IBAN) === 'undefined') {
            return '';
        }

        return state.sepa.placnik.IBAN;
    });

    const selectBrutoPremija = useSelector((state) => {
        if (typeof (state.produkt) === 'undefined') {
            return '';
        }
        else if (typeof (state.produkt.zavarovanaOseba) === 'undefined') {
            return '';
        }
        else if (typeof (state.produkt.zavarovanaOseba.premija) === 'undefined') {
            return '';
        }

        return formatDecimal(state.produkt.zavarovanaOseba.premija.bruto);
    });

    const krajPodpisa = useSelector((state) => {
        if (typeof (state.meta) === 'undefined') {
            return '';
        }
        else if (typeof (state.meta.krajPodpisa) === 'undefined') {
            return '';
        }

        return state.meta.krajPodpisa;
    });

    const selectPaket = useSelector((state) => {
        if (typeof (state.meta) === 'undefined') {
            return null;
        }
        else if (typeof (state.meta.paket) === 'undefined') {
            return null;
        }

        return state.meta.paket;
    });

    const selectRazmerje = useSelector((state) => {
        /*if (typeof(state.zavarovalec) === 'undefined' || typeof(state.produkt) === 'undefined' || typeof(state.produkt.zavarovanaOseba) === 'undefined' || typeof(state.produkt.zavarovanaOseba.davcnaStevila) === 'undefined') {
            return 'A';
        }

        let zavarovalecDavcna = */


        if (typeof (state.meta) === 'undefined') {
            return null;
        }

        let zavarovalecZavarovan = state.meta.zavarovalecZavarovan;
        if (typeof (zavarovalecZavarovan) === 'undefined') {
            return null;
        }

        let razmerje = 'A';
        if (!zavarovalecZavarovan) {
            razmerje = 'C';
        }

        return razmerje;
    });

    const selectZavarovanecDatumRojstvaTimestamp = useSelector((state) => {

        if (typeof (state.produkt) === 'undefined') {
            return null;
        }

        if (typeof (state.produkt.zavarovanaOseba) === 'undefined') {
            return null;
        }

        if (typeof (state.produkt.zavarovanaOseba.datumRojstva) === 'undefined') {
            return null;
        }

        let result = datumEuToTimestamp(state.produkt.zavarovanaOseba.datumRojstva);
        if (isNaN(result)) {
            return null;
        }

        return result;

    });

    const selectZavarovalecEmail = useSelector((state) => {

        if (typeof (state.zavarovalec) === 'undefined') {
            return null;
        }

        if (typeof (state.zavarovalec.email) === 'undefined') {
            return null;
        }

        /*if (typeof (state.produkt.zavarovanaOseba.pristopAbi) === 'undefined') {
            return null;
        }

        if (typeof (state.produkt.zavarovanaOseba.pristopAbi.izjavaGDPR) === 'undefined') {
            return null;
        }

        if (typeof(state.produkt.zavarovanaOseba.pristopAbi.izjavaGDPR.email) === 'undefined') {
            return null;
        }*/

        return state.zavarovalec.email;

    });

    const selectZavarovalecMobitel = useSelector((state) => {

        if (typeof (state.zavarovalec) === 'undefined') {
            return null;
        }

        if (typeof (state.zavarovalec.mobitel) === 'undefined') {
            return null;
        }

        /*if (typeof (state.produkt.zavarovanaOseba.pristopAbi) === 'undefined') {
            return null;
        }

        if (typeof (state.produkt.zavarovanaOseba.pristopAbi.izjavaGDPR) === 'undefined') {
            return null;
        }

        if (typeof (state.produkt.zavarovanaOseba.pristopAbi.izjavaGDPR.mobitel) === 'undefined') {
            return null;
        }*/

        return state.zavarovalec.mobitel;

    });

    /*const selectZavarovanaOsebaStarostRange = useSelector((state) => {
        // Razmerje A
        let datumRojstvaConfig = { deltaMin: 18, deltaMax: 65 };

        if (typeof (state.meta) === 'undefined') {
            return datumRojstvaConfig;
        }

        let zavarovalecZavarovan = state.meta.zavarovalecZavarovan;
        if (typeof (zavarovalecZavarovan) === 'undefined') {
            return datumRojstvaConfig;
        }
        
        if (!zavarovalecZavarovan) {
            datumRojstvaConfig = { deltaMin: 1, deltaMax: 18 };
        }

        return datumRojstvaConfig;

    });*/

    const selectOtpId = useSelector((state) => {
        if (typeof (state.appCore) === 'undefined') {
            return null;
        }
        else if (typeof (state.appCore.otp) === 'undefined') {
            return null;
        }
        else if (typeof (state.appCore.otp.id) === 'undefined') {
            return null;
        }

        return state.appCore.otp.id;
    });

    const selectOtpPotrditvenaKoda = useSelector((state) => {
        if (typeof (state.appCore) === 'undefined') {
            return '';
        }
        else if (typeof (state.appCore.otp) === 'undefined') {
            return '';
        }
        else if (typeof (state.appCore.otp.potrditvenaKoda) === 'undefined') {
            return '';
        }

        return state.appCore.otp.potrditvenaKoda;
    });

    const selectProduktBdbasic = useSelector((state) => {
        let defaultVal = 'Individualni';
        if (typeof (state.produkt) === 'undefined') {
            return defaultVal;
        }
        else if (typeof (state.produkt.zavarovanaOsebaArray) === 'undefined') {
            return defaultVal;
        }

        let zavarovanci = state.produkt.zavarovanaOsebaArray;
        if (zavarovanci.length <= 1) {
            return 'Individualni';
        }

        return 'Družinski';
    });

    const selectFrekvencaPlacila = useSelector((state) => {
        let defaultVal = 'MESECNO';
        if (typeof (state.produkt) === 'undefined') {
            return defaultVal;
        }
        if (typeof (state.produkt.nacinPlacila) === 'undefined') {
            return defaultVal;
        }
        else if (typeof (state.produkt.nacinPlacila.frekvenca) === 'undefined') {
            return defaultVal;
        }

        return state.produkt.nacinPlacila.frekvenca;

    });

    const { t, i18n } = useTranslation(['translation', 'validation', 'flashes', 'backend']);

    const handleFieldChange = (event, valueToUpperCase = true) => {

        // Find prefix.
        let fieldInfo = parseFieldName(event.target.name);
        let type = '';
        if (fieldInfo.prefix.length) {

            //type = prefix + '/updated';
            type = getActionType(fieldInfo.prefix, 'UPDATED');
            let normalizedValue = event.target.value;
            if (valueToUpperCase) {
                normalizedValue = inputValueToUpperCase(normalizedValue);
            }

            dispatch({
                type: type,
                payload: {
                    field: event.target.name,
                    value: normalizedValue
                }
            });
        }

    };

    const handleFieldChangeRaw = (event) => {
        handleFieldChange(event, false);
    }

    const handleFieldChangePrenosPodatkov = (event) => {
        handleFieldChange(event, false);
        setKopirajPodatke(event.target.value);
    }

    /*const handleFieldChangePrenosPodatkovAbi = (event) => {
        handleFieldChange(event, false);
        setKopirajPodatkeAbi(event.target.value);
    }*/

    const handlePodpisFieldChange = (fieldName, canvasAsString) => {
        /**
          * @todo How to do this better?
          */
        // We do this so we do not have to duplicate the logic from handleField change.
        const dummyEvent = {
            target: {
                name: fieldName,
                value: canvasAsString
            }
        };

        handleFieldChange(dummyEvent, false);
    };

    const handleDocumentPreviewClick = async (previewTipDokumenta) => {
        const validated = await validateForm();

        if (!validated) {
            M.toast({ html: t('validation:form.validate.preSubmit.failed') });
            return;
        }

        setPdfStatus('LOADING');

        let requestBody = buildRequest('preview', previewTipDokumenta);
        let itemPobnudbaService = new ItemPonudbaService();
        itemPobnudbaService.sendItemPonudbaForm(requestBody, 'itemsPonudbaBscCreate')
            .then((result) => {
                if (result.success) {

                    let copySteps = markInvalidTabs(allSteps, [], []);
                    setAllSteps([...copySteps]);

                    const copyDocuments = documents.map(doc => {
                        doc.isActive = false;
                        if (doc.apiId === previewTipDokumenta) {
                            doc.content = result.data.pdf.content;
                            doc.isActive = true;
                        }
                        return doc;
                    });
                    setDocuments([...copyDocuments]);
                    //setSignedPdfContent(result.data.pdf.content);
                    setPdfStatus('LOADED');
                    M.toast({ html: t("flashes:submission.preview.successful") });
                }
                else {
                    
                    const { clientErrors, tabs } = mapErrorsToForm(result.errors);
                    appLogDebug("tabs to mark ", tabs);
                    let i = 0;
                    while (i < clientErrors.length) {
                        markInput(clientErrors[i], 'APPLY_ERRORS');
                        i++;
                    }

                    let copySteps = markInvalidTabs(allSteps, tabs, []);
                    setAllSteps([...copySteps]);
                    
                    setPdfStatus('FAILED');
                    M.toast({ html: t(result.message) });
                }
                
            })
            .catch(error => {
                setPdfStatus('FAILED');
                M.toast({ html: t("flashes:form.error.preview") });
            });

    };

    const buildRequest = (requestId, previewTipDokumenta=null) => {

        const state = store.getState(); 
        const ponudba = JSON.parse(JSON.stringify(state));
        delete ponudba.appCore;

        // We need to put new attribute on root of ponudba. 
        if (previewTipDokumenta !== null) {
            ponudba.rootPonudba['previewTipDokumenta'] = previewTipDokumenta;
        }

        let requestBody = {
            form: {
                type: 'DrBestBasicForm',
                action: 'preview',
            },
            ponudba: {
                type: 'EurekoPonudba',
                data: ponudba
            },
            otp: {
                type: "AppTypeOtp",
                data: state.appCore.otp
            }
        };

        if (requestId === 'submit') {
            requestBody.form.action = 'submit';
        }

        return requestBody;
    };

    const validateForm = async () => {        

        let sigFailedTabs = [], 
            inpFailedTabs = validateFormInputs(allSteps);
        let potrditvenaKodaErrorObject = await validatePotrditvenaKoda(
            selectOtpPotrditvenaKoda,
            selectZavarovalecEmail,
            selectZavarovalecMobitel,
            selectOtpId
        );

        console.debug('potrditvenakoda error ', potrditvenaKodaErrorObject);
        setPotrditvenaKodaError(potrditvenaKodaErrorObject);
        if (potrditvenaKodaErrorObject.hasError) {
            inpFailedTabs.push('veljavnost-podatkov');
        }

        // Check podpisi.
        let copyPodpisiErrors = {...podpisiErrors}, podpisValidation;
        
        // sepa
        podpisValidation = validateFormSignature(selectSepaPlacnikPodpisPlacnika, true);
        if (podpisValidation.hasError) {
            copyPodpisiErrors['sepaplacnik_podpisPlacnika'] = podpisValidation;
            sigFailedTabs.push('sepa');
        }

        // izjava
        podpisValidation = validateFormSignature(selectProduktPodpisZavarovalec, true);
        if (podpisValidation.hasError) {
            copyPodpisiErrors['produkt_podpisZavarovalec'] = podpisValidation;
            sigFailedTabs.push('izjava');
        }

        /*podpisValidation = validateFormSignature(selectZavarovanecIzjavaZavarovancaPodpisZavarovanec, true);
        if (podpisValidation.hasError) {
            copyPodpisiErrors['zavarovanec_izjavazavarovanca_podpisZavarovanec'] = podpisValidation;
            sigFailedTabs.push('izjava');
        }*/

        // gdpr
        podpisValidation = validateFormSignature(selectZavarovalecAmTrustIzjavaGdprPodpis, true);
        if (podpisValidation.hasError) {
            copyPodpisiErrors['zavarovalec_amtrust_izjavagdpr_podpis'] = podpisValidation;
            sigFailedTabs.push('gdpr');
        }

        /*podpisValidation = validateFormSignature(
            selectZavarovanecIzjavaGdprPodpis, 
            ( (selectRazmerje === 'C') ? true : false )
        );
        if (podpisValidation.hasError) {
            copyPodpisiErrors['zavarovanec_izjavagdpr_podpis'] = podpisValidation;
            sigFailedTabs.push('gdpr');
        }*/

        appLogDebug('copyPodpisiErrors ', copyPodpisiErrors);
        
        setPodpisiErrors({...copyPodpisiErrors});
        let copyAllSteps = markInvalidTabs(
            [...allSteps], 
            sigFailedTabs, 
            inpFailedTabs
        );

        
        setAllSteps([...copyAllSteps]);

        if (sigFailedTabs.length !== 0 || inpFailedTabs.length !== 0) {
            return false;
        }
        
        return true;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) {
            setStatus('');
            M.toast({ html: t('validation:form.validate.preSubmit.failed') });
            return;
        }
        setStatus('SUBMITTING');

        let requestBody = buildRequest('submit');
        let itemPobnudbaService = new ItemPonudbaService();
        itemPobnudbaService.sendItemPonudbaForm(requestBody, 'itemsPonudbaBscCreate')
            .then((result) => {
                if (result.success) {
                    M.toast({ html: t("flashes:submission.successful") });
                    setStatus('SUBMITTED');

                }
                else {
                    setStatus('');
                    M.toast({ html: t("flashes:submission.error") });
                }
            })
            .then((result) => {
            })
            .catch(error => {
                setStatus('');
                M.toast({ html: "Another error" });
            });

    };    

    const handleSendOtpClick = async (event) => {
        event.preventDefault();
        appLogDebug("handleSetOptClick form function");

        let email = null, mobitel = null;
        if (typeof(selectZavarovalecEmail) === 'string' && selectZavarovalecEmail.length) {
            email = selectZavarovalecEmail;
        }

        if (typeof(selectZavarovalecMobitel) === 'string' && selectZavarovalecMobitel.length) {
            mobitel = selectZavarovalecMobitel;
        }
        
        appLogDebug("email/mobitel ", email, mobitel);

        if (email === null && mobitel === null) {
            return;
        }

        let message = t('translation:field.verificationCode.errorMessage'); 
        let idService = new IdentityService();
        idService.sendVerificationCode({
            email: email,
            mobitel: mobitel

        }).then((responseResult) => {

            setPotrditvenaKodaSent(responseResult.success);
            if (responseResult.success) {
                message = t('translation:field.verificationCode.successMessage');

                const otpId = responseResult.data.otp.id;
                dispatch({
                    type: APP_CORE_OTP_UPDATED,
                    payload: {
                        field: 'id',
                        value: otpId
                    }
                });

            }
            
        }).catch((error) => {
            setPotrditvenaKodaSent(false);
            
        }).finally(() => {
            M.toast({ html: message });
        });
        
    };

    const activateStep = (stepToActivate) => {
        allSteps.forEach(step => { step.isActive = step.tab === stepToActivate.tab; });
        setCurrentStep(stepToActivate);
        /*if (stepToActivate.tab === 'zavarovanec-data') {
            setForceRerender(String(Math.random()));
        }*/
        setTimeout(() => {
            window.scroll(0, 0);
        }, 10);
    };

    /**
     * @todo Move to eureko-lib
     * @returns 
     */
    const validatePotrditvenaKoda = async (potrditvenaKoda, email, mobitel, otpId) => {

        if (typeof(potrditvenaKoda) !== 'string' || potrditvenaKoda === '') {
            return {
                hasError: true,
                required: true
            };
        }

        if (potrditvenaKoda.match(/^([0-9]){6}$/) === null) {
            return {
                hasError: true,
                invalidValue: true
            };
        }

        let usedEmail = null, usedMobitel = null;
        if (typeof(email) === 'string' && email !== '') {
            usedEmail = email;
        }

        if (typeof(mobitel) === 'string' && mobitel !== '')  {
            usedMobitel = mobitel;
        }

        if (usedEmail === null && usedMobitel === null) {
            return {
                hasError: true,
                invalidValue: true
            };
        }

        let objError = {
            hasError: false
        };

        let idService = new IdentityService();
        await idService.checkVerificationCode({
            email: usedEmail,
            mobitel: usedMobitel,
            id: otpId,
            potrditvenaKoda: potrditvenaKoda
        }).then((response) => {

            objError.hasError = !response.success;
            if (objError.hasError) {
                objError['invalidValue'] = true;
            }
            
        })
        .catch((error) => {
            // Should we return different validation error?
            /**
             * @todo What error we set if api call fails?
             */
            objError.hasError = true;
            objError['invalidValue'] = true;
        });

        return objError;
    };

    useEffect(() => {

        if (selectOtpId === null) {
            setPotrditvenaKodaError({hasError: false});
        }
        else {
            validatePotrditvenaKoda(
                selectOtpPotrditvenaKoda,
                selectZavarovalecEmail,
                selectZavarovalecMobitel,
                selectOtpId
            ).then(errorObj => {
                appLogDebug("errorObj ", errorObj);
                setPotrditvenaKodaError(errorObj);
            });
        }
    }, [
        selectOtpPotrditvenaKoda,
        selectOtpId,
        dispatch
    ]);

    /**
     * We have to invalidate potrditvena koda
     */
    useEffect(() => {
        dispatch({
            type: APP_CORE_OTP_UPDATED,
            payload: {
                field: 'id',
                value: null
            }
        });

        if (selectOtpPotrditvenaKoda !== '') {
            validatePotrditvenaKoda(
                selectOtpPotrditvenaKoda,
                selectZavarovalecEmail,
                selectZavarovalecMobitel,
                selectOtpId
            ).then(errorObj => {
                setPotrditvenaKodaError(errorObj);
            });
        }
    }, [
        selectZavarovalecEmail,
        selectZavarovalecMobitel,
        dispatch
    ]);

    useEffect(() => {
        M.AutoInit();

    }, []);

    useEffect(() => {
        document.title = "Basic - " + currentStep.title + " | Pridruži se Dr Best";
        const gtmDataLayerVars = {
            gtmId: process.env.REACT_APP_GTM_ID,
            auth: process.env.REACT_APP_GTM_AUTH,
            preview: process.env.REACT_APP_GTM_PREVIEW,
            events: {
                event: 'Page Title Change',
                eurekoEventTrigger: 'formTabSwitch',
                eurekoForm: 'DrBestBscForm',
                eurekoPage: 'DrBestEurekoRoute',
                eurekoPageTitle: document.title
            },
            // dataLayerName: 'PageDataLayer'
        };
        // TagManager.dataLayer(gtmDataLayerVars);
        TagManager.initialize(gtmDataLayerVars);

    }, [currentStep]);

    // On successful submission redirect to ty page.
    useEffect(() => {
        if (status === 'SUBMITTED') {
            navigate('/skljeno-zavarovanje-eureko');
        }
    }, [status, navigate]);

    useEffect(() => {
        let bdcaPremija = new BdcaPremija();
        bdcaPremija.setCalcParam('paket', selectPaket);
        bdcaPremija.setCalcParam('produktBdBasic', selectProduktBdbasic);
        bdcaPremija.setCalcParam('frekvenca', selectFrekvencaPlacila);
        appLogDebug('premija params ', { selectPaket, selectProduktBdbasic, selectFrekvencaPlacila });
        appLogDebug('premija params validated ', bdcaPremija.validateParams());

        if (!bdcaPremija.validateParams()) {
            return;
        }

        bdcaPremija.calculate();

        dispatch({
            type: ZAVAROVANEC_PREMIJA_UPDATED,
            payload: {
                field: 'neto',
                value: bdcaPremija.getPremijaNeto()
            }
        });

        dispatch({
            type: ZAVAROVANEC_PREMIJA_UPDATED,
            payload: {
                field: 'davek',
                value: bdcaPremija.getPremijaDavek()
            }
        });

        dispatch({
            type: ZAVAROVANEC_PREMIJA_UPDATED,
            payload: {
                field: 'bruto',
                value: bdcaPremija.getPremijaBruto()
            }
        });

    }, [
        selectPaket, 
        selectProduktBdbasic, 
        selectFrekvencaPlacila,
        dispatch
    ]);

    return (

        <form onSubmit={handleSubmit} noValidate={true}>
            { /** BEGIN: tabs */}
            <div className="row">
                <div className="col s12">
                    <ul
                        className="custom-tabs"
                    >
                        {
                            allSteps.map(step => {
                                let classAdd = ' ';
                                if (step.error) classAdd += 'red';
                                if (step.isActive) classAdd += ' active';
                                return (
                                    <li
                                        key={step.tab}
                                        className={"cutom-tab darken-1 white-text" + classAdd}
                                        onClick={event => { event.preventDefault(); activateStep(step); }}
                                        role="navigation"
                                    >
                                        <span>
                                            {step.text}
                                        </span>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </div>
            { /** END: tabs */}

            <div
                className="row"
            >

                {
                    /** --- BEGIN: zavarovalec-data --- */
                    <div
                        id="zavarovalec-data"
                        className={"col s12 " +
                            (currentStep.tab === 'zavarovalec-data' ? "" : "hide")
                        }
                    >
                        <fieldset>
                            <legend>Osnovni podatki</legend>
                            <hr className="eureko-hr-2" />
                            <HiddenField 
                                prefix="meta_" 
                                onChange={handleFieldChangeRaw} 
                                name="appClientId"
                                value={typeof (props.channel) === 'string' ? props.channel : ''} 
                            />
                            <div className="row">
                                <ImeField 
                                    prefix="zavarovalec_" 
                                    onImeChange={handleFieldChange}
                                    onPriimekChange={handleFieldChange}
                                    isReadOnly={false}
                                />
                            </div>
                            <div className="row">
                                <EmailField 
                                    prefix="zavarovalec_" 
                                    isRequired={true} 
                                    isReadOnly={false}
                                    onChange={handleFieldChange}
                                />
                                <MobitelField 
                                    prefix="zavarovalec_" 
                                    isRequired={true} 
                                    isReadOnly={false}
                                    onChange={handleFieldChange}
                                />
                                <SpolField 
                                    prefix="zavarovalec_" 
                                    onChange={handleFieldChange} 
                                />
                            </div>
                            <div className="row">
                            <DatumRojstvaField prefix="zavarovalec_" onChange={handleFieldChange} conf={{ deltaMin: 18, deltaMax: null }} />
                            {/*<DrzavaRojstvaTextField prefix="zavarovalec_"  onChange={handleFieldChange} />*/}
                            <DavcnaStevilkaField prefix="zavarovalec_" onChange={handleFieldChange} />    
                            </div>
                            
                        </fieldset>
                        <fieldset>
                            <legend>Naslov prebivališča</legend>
                            <hr className="eureko-hr-2" />
                            <NaslovField prefix="zavarovalec_naslov_" onChange={handleFieldChange} />
                        </fieldset>
                        <fieldset>
                            <legend>Osebni dokument</legend>
                            <hr className="eureko-hr-2" />
                            
                            <div className="row">
                                <OsebniDokumentIdField prefix="zavarovalec_osebnidokument_" onChange={handleFieldChange} />
                                <OsebniDokumentTipField prefix="zavarovalec_osebnidokument_" onChange={handleFieldChange} />
                                <OsebniDokumentDatumIzdajeField prefix="zavarovalec_osebnidokument_" onChange={handleFieldChange} />
                                <OsebniDokumentIzdajateljField prefix="zavarovalec_osebnidokument_" onChange={handleFieldChange} />
                            </div>
                            
                        </fieldset>
                    </div>
                    /** --- END: zavarovalec-data --- */
                }

                {
                    /** --- BEGIN: zavarovanec-data --- */
                    <div
                        id="zavarovanec-data"
                        className={"col s12 " +
                            (currentStep.tab === 'zavarovanec-data' ? "" : "hide")
                        }
                    >
                        <HiddenField prefix="produkt_" onChange={handleFieldChangeRaw} name="produkt" value="Individualni" />
                        <fieldset>
                            <legend>Zavarovanci</legend>
                            <hr className="eureko-hr-2" />
                            <p>
                            K polici lahko dodate tudi svoje družinske člane: zakonca ali partnerja ter otroke do 18. oziroma odvisne otroke do 35. leta starosti (tudi zakončeve), ki živijo na enakem naslovu (podrobneje opisano v 1. členu splošnih pogojev). Premija za celotno družino znaša 9,90 evrov mesečno.
                            </p>
                            <ZavarovanciArrayField prefix="zavarovanecarray_" maxZavarovanciCount={6} />
                        </fieldset>
                    </div>
                    /** --- END: zavarovanec-data --- */
                }

                {
                    /** --- BEGIN: premija --- */
                    <div
                        id="premija"
                        className={"col s12 " +
                            (currentStep.tab === 'premija' ? "" : "hide")
                        }
                    >
                        <fieldset>
                            <legend>Premija</legend>
                            <hr className="eureko-hr-2" />
                            <MessageBox category="warning">
                                    Prvo premijo lahko poravnate s plačilnim nalogom (takoj) ali soglasjem za direktno obremenitev (ob datumu prve obremenitve). Vse naslednje premije se poravnajo z direktno bremenitvijo, ki jo izpolnite na zavihku <b>SEPA</b>.
                            </MessageBox>
                            <div className="row">
                                <div className="col s4">
                                    <b style={{fontSize: '1.1em'}}>Način plačila prve premije</b>
                                    <NacinPlacilaField 
                                        prefix="rootponudba_"
                                        fieldName="placiloPrvePremija"
                                        onChange={handleFieldChange}
                                    />
                                </div>
                                
                            </div>
                            {/*<HiddenField prefix="nacinplacila_" onChange={handleFieldChange} name="frekvenca" value="MESECNO" />*/}
                            <FrekvencaField prefix="nacinplacila_" onChange={handleFieldChange} />
                            <div className="row">
                                <div className="col s12">
                                    Premije veljajo od januarja 2023. Premije se v prihodnosti lahko spremenijo na način, določen v Splošnih pogojih za 
                                    prostovoljno zdravstveno zavarovanje Dr Best Basic AX-BA-SI_1_2023. Premija se v skladu z 10. členom Splošnih pogojev 
                                    zviša ob koncu zavarovalnega leta, v katerem je zavarovanec prestopil v višji starostni razred. Za informacije v zvezi z vašo polico kontaktirajte 080 88 12. Davek od prometa zavarovalnih poslov (DPZP) 8,5 %.
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col s12">
                                    <CenaField 
                                        prefix="zavarovanec_premija_" 
                                        onChange={handleFieldChange} 
                                    />
                                </div>
                            </div>
                            
                        </fieldset>

                    </div>
                    /** --- END: premija --- */
                }

                {
                    /** --- BEGIN: sepa --- */
                    <div
                        id="sepa"
                        className={"col s12 " +
                            (currentStep.tab === 'sepa' ? "" : "hide")
                        }
                    >
                        <div className="row">
                            <div className="col s12">
                            <PrenosPodatkovField
                                prefix="meta_"
                                name="kopiranSepaPlacnik"
                                kopirajPodatke={kopirajPodatke}
                                onChange={handleFieldChangePrenosPodatkov}
                                texts={{
                                    'legendText': "Izbira plačnika",
                                    'neKopirajText': "Druga oseba",
                                    'kopirajText': "Zavarovalec"
                                }}

                                mapFields={[
                                    {
                                        src: 'zavarovalec_ime',
                                        dst: 'sepaplacnik_ime'
                                    },
                                    {
                                        src: 'zavarovalec_priimek',
                                        dst: 'sepaplacnik_priimek'
                                    },
                                    {
                                        src: 'zavarovalec_naslov_naslovUlica',
                                        dst: 'sepaplacnik_naslov_naslovUlica'
                                    },
                                    {
                                        src: 'zavarovalec_naslov_naslovPosta',
                                        dst: 'sepaplacnik_naslov_naslovPosta'
                                    },
                                    {
                                        src: 'zavarovalec_naslov_naslovKraj',
                                        dst: 'sepaplacnik_naslov_naslovKraj'
                                    }]}
                            />
                            </div>
                        </div>
                        

                        <fieldset className={(selectKopiranSepaPlacnik === false) ? "" : "hide"}>
                            <legend>Plačnik</legend>
                            <hr className="eureko-hr-2" />
                            <div className="row">
                                <ImeField prefix="sepaplacnik_" onImeChange={handleFieldChange} onPriimekChange={handleFieldChange} />
                            </div>
                        </fieldset>
                        <fieldset className={(selectKopiranSepaPlacnik === false) ? "" : "hide"}>
                            <legend>Naslov prebivališča</legend>
                            <NaslovField prefix="sepaplacnik_naslov_" onChange={handleFieldChange} />
                        </fieldset>
                        <fieldset>
                            <legend>Transakcijski račun</legend>
                            <hr className="eureko-hr-2" />
                            <div className="row">
                                <IbanField prefix="sepaplacnik_" onChange={handleFieldChange} relatedInputs={
                                    { 'imeBankeInput': imeBankeInput }
                                } />
                                <ImeBankeField ref={imeBankeInput} prefix="sepaplacnik_" onChange={handleFieldChange} />
                            </div>
                        </fieldset>
                        <fieldset>
                            <legend>Naziv prejemnika plačila</legend>
                            <hr className="eureko-hr-2" />
                            <div className="row">
                                <div className="col s12">
                                    EUREKO, zavarovalno zastopniška družba, d.o.o.<br />
                                    Leskoškova 9e, 1000 Ljubljana<br />
                                    Ident. oznaka prejemnika plačila: SI95ZZZ57823715<br />
                                    Transakcijski račun: SI56 0400 1004 8779 640<br />
                                </div>
                            </div>
                        </fieldset>
                        <fieldset>
                            <legend>Časovno obdobje plačila</legend>
                            <hr className="eureko-hr-2" />
                            <div className="row">
                                <div className="col s12">
                                    Pooblaščam (A) EUREKO, zavarovalno zastopniška družba, d.o.o., Leskoškova 9e, 1000 Ljubljana, da posreduje navodila vašemu ponudniku plačilnih storitev za obremenitev vašega plačilnega računa in (B) vašega ponudnika plačilnih storitev, da bremeni vaš plačilni račun  v skladu z navodili, ki jih posreduje EUREKO, zavarovalno zastopniška družba, d.o.o.. Strinjate se, da bo EUREKO, d.o.o. posebej obveščal le o vsaki spremembi višine obremenitve vašega plačilnega računa. Vaše pravice obsegajo tudi pravico do povračila denarnih sredstev iz strani vašega ponudnika plačilnih storitev v skladu s splošnimi pogoji vašega ponudnika plačilnih storitev. Povračilo denarnih sredstev je potrebno terjati v roku 8 tednov, ki prične teči od dne, ko je bil bremenjen vaš plačilni račun.
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col s12">
                                    <AgreeField prefix="meta_"
                                        name="casovnoObdobjePlacilaPotrditev" onChange={handleFieldChange}
                                        isRequired={true}
                                        text="potrjujem"
                                    />
                                </div>
                                <KrajPodpisaField 
                                    prefix="meta_"
                                    onChange={handleFieldChange}
                                />
                            </div>
                            
                            <HiddenField prefix="sepaplacnik_"
                                name="krajPodpisa"
                                onChange={handleFieldChange}
                                value={krajPodpisa}
                            />
                        </fieldset>

                        <fieldset>
                            <legend>Podpisi za Obrazec SEPA</legend>
                            <hr className="eureko-hr-2" />
                            {currentStep.tab === 'sepa' ? <PodpisField1
                                    isRequired={true}
                                    onChange={handlePodpisFieldChange.bind(null, "sepaplacnik_podpisPlacnika")}
                                    name={"sepaplacnik_podpisPlacnika"}
                                    questionText={t('field.label.signaturePayer')}
                                    error={podpisiErrors['sepaplacnik_podpisPlacnika']}
                                    value={selectSepaPlacnikPodpisPlacnika}
                                /> : ''}
                            <HiddenField prefix="sepaplacnik_"
                                onChange={handleFieldChange}
                                name="krajPodpisa"
                                value={krajPodpisa}
                            />
                        </fieldset>
                    </div>
                    /** --- END: sepa --- */
                }

                {
                    /** --- BEGIN: izjava --- */
                    <div
                        id="izjava"
                        className={"col s12 " +
                            (currentStep.tab === 'izjava' ? "" : "hide")
                        }
                    >
                        <div className="row">
                            <div className="col s12">
                                <fieldset>
                                    <legend>Izjave</legend>
                                    <hr className="eureko-hr-2" />
                                    <div className="row">
                                        <div className="col s12">
                                            Podpisani izjavljam, da so podatki in odgovori po mojem najboljšem vedenju točni in ažurni. Zavedam se, da lahko v primeru namerne neresnične prijave ali namernega zamolčanja kakšne okoliščine take narave, da zavarovalnica ne bi sklenila zavarovanja, če bi vedela za resnično stanje stvari, zavarovalnica v času trajanja zavarovanja zahteva razveljavitev zavarovanja. Če je zavarovanje razveljavljeno iz navedenih razlogov, obdrži zavarovalnica že plačane premije in ima pravico zahtevati plačilo premije za zavarovalno dobo, v kateri je zahtevala razveljavitev zavarovanja. Zavarovanec je seznanjen z dejstvom, da bo zavarovalnica na podlagi odgovorov na zavarovančeva vprašanja, podanih v tej ponudbi, presodila, ali zavarovanec izpolnjuje pogoje za zavarovanje Critical Advantage™, skladno z določbo 4. člena Splošnih pogojev. Zavarovalnica skladno z veljavno zakonodajo na področju varstva osebnih podatkov ter vsemi zadevnimi zahtevami in priporočili oblasti obvešča, da morajo zavarovalec in zavarovanci ali njihovi zakoniti zastopniki za zagotavljanje skladnosti, uvedbo, nadzorovanje in izvajanje zdravstvenih storitev, ki so sestavni del zavarovalne pogodbe, dati izrecno privolitev, da lahko zavarovalnica njihove osebne podatke, vključno z zdravstvenimi podatki in vsemi podatki, ki izhajajo iz njihovega sodelovanja z zavarovalnico in vsemi strokovnjaki, povezanimi z zavarovanimi storitvami, obdeluje in hrani v svoji zbirki. Zavarovalnica obvešča zavarovanca, da bo njegove osebne podatke razkrila le, ko bo to nujno potrebno za izvajanje sklenjene zavarovalne pogodbe in skladno z zahtevami veljavne zakonodaje. Posameznik, na katerega se osebni podatki nanašajo, prav tako izrecno soglaša s predložitvijo potrebnih podatkov vsaki vpleteni pozavarovalnici in tretjim osebam, ki so odgovorne za zahtevke, katerih stroške delno ali v celoti krije zavarovalnica, da lahko ta uveljavlja pravico do njihove povrnitve.
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend>Izvensodno reševanje sporov</legend>
                                    <hr className="eureko-hr-2" />
                                    <div className="row">
                                        <div className="col s12">
                                            V primeru nestrinjanja s končno odločitvijo zavarovalnice, se lahko po posebnem dogovoru nadaljuje postopek za izvensodno rešitev spora pri Mediacijskem centru, ki deluje v okviru Slovenskega zavarovalnega združenja, e-pošta: <a href="mailto:info@zav-zdruzenje.si">info@zav-zdruzenje.si</a>, tel.: +386 1 3009 381.
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend>Plačilo premije</legend>
                                    <hr className="eureko-hr-2" />
                                    <div className="row">
                                        <div className="col s12">
                                            Strinjam se s periodičnim (mesečnim) plačilom premije iz računa <b>{selectPlacnikIban}</b> v znesku <b>{selectBrutoPremija} EUR</b>, 18. dan v vsakem mesecu.
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend>Potrjujem prejem oziroma soglasje</legend>
                                    <hr className="eureko-hr-2" />
                                    {selectPaket === 'BDCA_BASIC' &&
                                        <AgreeField prefix="meta_"
                                            name="soglasjeBasic"
                                            onChange={handleFieldChange}
                                            isRequired={true}
                                            text="s ponudbo za sklenitev prostovoljnega zdravstvenega zavarovanja Dr Best Basic"
                                        /> &&
                                        <AgreeField
                                            prefix="meta_"
                                            name="soglasjePogojiBasic"
                                            onChange={handleFieldChange}
                                            isRequired={true}
                                        >
                                            s splošnimi pogoji za prostovoljno zdravstveno zavarovanje <a target="_blank" rel="noreferrer" href={DOCUMENT_URLS.SPLOSNI_POGOJI_BASIC}>Dr Best Basic AX-BA-SI_01_2023</a>
                                        </AgreeField>
                                    }

                                    <AgreeField prefix="meta_"
                                        name="soglasjeVarstvoPodatkov"
                                        onChange={handleFieldChange}
                                        isRequired={true}
                                    >
                                        s privolitveno izjavo <a target="_blank" rel="noreferrer" href={DOCUMENT_URLS.AMTRUST_GDPR}>obvestilom o zasebnosti ter varstvu osebnih podatkov</a>
                                    </AgreeField>

                                    <AgreeField prefix="meta_"
                                        name="soglasjeIpid"
                                        onChange={handleFieldChange}
                                        isRequired={true}
                                    >
                                        z dokumentom z informacijami o zavarovalnem produktu (IPID) v skladu z evropsko Direktivo o distribuciji zavarovalnih produktov <a target="_blank" rel="noreferrer" href={DOCUMENT_URLS.IPID_BASIC}>IPID</a>
                                    </AgreeField>
                                    <div className="row">
                                        <DaNeField 
                                            prefix="produkt_"
                                            stringId="soglasjeZaObvescanje"
                                            onChange={handleFieldChange}
                                        >
                                            v zvezi z izvajanjem sklenjene pogodbe izrecno soglašam, da me zavarovalnica o vseh zadevah v zvezi z vsemi sklenjenimi in bodočimi zavarovalnimi pogodbami lahko obvešča izključno po elektronski pošti na e-naslov, ki je naveden v tej ponudbi z sklenitev zavarovanja. To vključuje vse obveščanje, kot ga določa Zakon o zavarovalništvu, vključno z informacijami o zavarovalnem produktu (IPID), ter pošiljanjem UPN in drugih obvestil po elektronski pošti. Seznanjen sem, da moram spremembo elektronskega naslova nemudoma sporočiti zavarovalnici, ter da lahko kadarkoli prekličem soglasje za obveščanje, in sicer s pisno zahtevo, poslano po elektronski pošti na e-naslov: <a href='mailto:info@dr-best.si'>info@dr-best.si</a>, ali po navadni pošti na sedež zavarovalnice.
                                        </DaNeField>
                                    </div>
                                    
                                </fieldset>

                                <fieldset>
                                    <legend>Podpis izjave</legend>
                                    <hr className="eureko-hr-2" />
                                    {currentStep.tab === 'izjava' ? <PodpisField1
                                            isRequired={true}
                                            onChange={handlePodpisFieldChange.bind(null, "produkt_podpisZavarovalec")}
                                            name={"produkt_podpisZavarovalec"}
                                            questionText={t('field.label.signatureCustomer')}
                                            error={podpisiErrors['produkt_podpisZavarovalec']}
                                            value={selectProduktPodpisZavarovalec}
                                        /> : ''}
                                    <HiddenField prefix="produkt_"
                                        name="krajPodpisa"
                                        onChange={handleFieldChange}
                                        value={krajPodpisa}
                                    />
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    /** --- END: izjava --- */
                }

                {
                    /** --- BEGIN: gdpr --- */
                    <div
                        id="gdpr"
                        className={"col s12 " +
                            (currentStep.tab === 'gdpr' ? "" : "hide")
                        }
                    >

                        <fieldset>
                            <legend>GDPR Zavarovalec</legend>
                            <hr className="eureko-hr-2" />
                            <DaNeField prefix="zavarovalec_amtrust_izjavagdpr_"
                                stringId="q61"
                                onChange={handleFieldChange}
                            >
                                Kjer ste podali soglasje, si lahko osebne podatke, ki ste nam jih posredovali, izmenjujemo znotraj družb v skupini in z drugimi podjetji, s katerimi vzpostavljamo poslovne povezave, navedene v 3. točki <a href={DOCUMENT_URLS.AMTRUST_GDPR}>obvestila o zasebnosti ter varstvu osebnih podatkov</a>.
                            </DaNeField>

                            {
                                (selectZavarovalecAmTrustIzjavaGdprHasWarning === true) ? 
                                    <div className="col s12">
                                        <MessageBox category="warning">
                                            To dovoljenje je ključno za nemoteno izvajanje storitev. Da bi slednje kar najbolje izkoristili, priporočamo, da odgovorite z da.
                                        </MessageBox>
                                    </div>
                                    : ''
                            }

                            <DaNeKanaliGroup prefix="zavarovalec_amtrust_izjavagdpr_"
                                questionStringId="q611"
                                kanalBasePrefix="q62_"
                                question="Za namen izvajanja segmentiranega (neposrednega) trženja, ki vključuje obvestila o novih izdelkih, storitvah ali ponudbah, za katere menimo, da vas zanimajo, ali da vam nudimo komercialne novosti, vse na podlagi vašega profila, kar pomeni oblikovanje vašim potrebam, željam, zahtevam in interesom prilagojenih ponudb, vas lahko oni in mi kontaktiramo preko:"
                                onChange={handleFieldChange}
                                showKanali={selectZavarovalecAmTrustGdprKanaliShow}
                                isKanalRequired={selectIsZavarovalecAmTrustGdprKanalRequired}
                            />

                            {currentStep.tab === 'gdpr' ? <PodpisField1
                                    isRequired={true}
                                    onChange={handlePodpisFieldChange.bind(null, "zavarovalec_amtrust_izjavagdpr_podpis")}
                                    name={"zavarovalec_amtrust_izjavagdpr_podpis"}
                                    questionText={t('field.label.signatureCustomer')}
                                    error={podpisiErrors['zavarovalec_amtrust_izjavagdpr_podpis']}
                                    value={selectZavarovalecAmTrustIzjavaGdprPodpis}
                                /> : ''}
                        </fieldset>
                    </div>
                    /** --- END: gdpr --- */
                }

                {
                    /** --- BEGIN: veljavnost-podatkov --- */
                    <div 
                        id="veljavnost-podatkov"
                        className={"col s12 " + 
                            (currentStep.tab === 'veljavnost-podatkov' ? "" : "hide")

                        }
                    >
                        <fieldset>
                            <p>
                            Pred oddajo obrazca moramo potrditi veljavnost vaših podatkov. Izberite “pošlji potrditveno kodo”, odprite prejeto e-mail ali SMS sporočilo in vpišite potrditveno kodo spodaj
                            </p>

                            <PotrditvenaKoda2Field prefix="appcore_otp_" 
                                onChange={handleFieldChangeRaw}
                                onSendOtpClick={handleSendOtpClick}
                                error={potrditvenaKodaError}
                                isRequired={true}
                            />
                        </fieldset>

                    </div>
                    /** --- END: veljavnost-podatkov --- */
                }

                {
                    /** --- BEGIN: form-final --- */
                    <div 
                        id="form-final" 
                        className={"col s12 " + 
                            (currentStep.tab === 'form-final' ? "" : "hide")
                        }
                    >
                        <AgreeField 
                            prefix="meta_" 
                            name="soglasjePrejemDokumentacije" 
                            onChange={handleFieldChange}
                            isRequired={true}
                            text="Stranka se strinja, da bo sklepalno dokumentacijo prejela po e-pošti in da se z njo lahko komunicira elektronsko in sicer po e-pošti, telefonu ali s pomočjo mobilnih in spletnih  aplikacij. Stranka je seznanjena, da lahko to soglasje kadarkoli umakne s pisno izjavo po navadni ali e-pošti." 
                        /> 
                        <Predogled2Table 
                            allowedDocuments={documents.filter(doc => doc.isAllowed)}
                            onClick={handleDocumentPreviewClick}
                        />
                        <Predogled2Area 
                            pdfStatus={pdfStatus}
                            document={documents.find(el => {
                                return (el.isActive && el.isAllowed) ? el.content : undefined;
                            })} 
                        />
                        <FormSubmitField 
                            formStatus={status}
                            enabledButtonText={'Oddaj obrazec'}
                            disabledButtonText={'Prosimo počakajte'}
                        />
                    </div>
                    /** --- END: form-final --- */
                }

            </div>

            { /** BEGIN: next/prev button */}
            <div className="row">
                <div className="col m4">
                    <FormStepButtonField
                        role="previous"
                        allSteps={allSteps}
                        onClick={() => activateStep(findPreviousStep(allSteps))}
                        disabled={currentStep.step === 1}
                    />
                </div>
                <div className="col m4 offset-m3">
                    <FormStepButtonField
                        role="next"
                        allSteps={allSteps}
                        onClick={() => activateStep(findNextStep(allSteps))}
                        disabled={
                            currentStep.step === 10 ||
                            (currentStep.step === 9 && potrditvenaKodaError.hasError === true)
                        }
                    />
                </div>
            </div>
            { /** END: next/prev button */}

        </form>


    );

}

function findNextStep(allSteps) {
    let stepIndex = 0;
    allSteps.find((step, index) => {
        if (step.isActive) stepIndex = index;
        return step.isActive;
    });

    return allSteps[stepIndex + 1];
}

function findPreviousStep(allSteps) {
    let stepIndex = 0;
    allSteps.find((step, index) => {
        if (step.isActive) stepIndex = index;
        return step.isActive;
    });

    return allSteps[stepIndex - 1];
}

